import React from 'react';
import { Button, EmptyContent, Flex } from '@/components/ui';
import { IconFileSpreadsheet, IconUpload } from '@tabler/icons-react';

interface CsvFilesEmptyStateProps {
  onUploadClick: () => void;
}

export const CsvFilesEmptyState: React.FC<CsvFilesEmptyStateProps> = ({
  onUploadClick,
}) => {
  return (
    <EmptyContent
      style={{ alignSelf: 'center', minHeight: '400px' }}
      withIconBox
      icon={<IconFileSpreadsheet />}
      // icon={<FileFormatIcon fileName="file.csv" />}
      title="No CSV files uploaded yet"
      description="Start by uploading your first CSV file. You can drag & drop files anywhere on this page or use the upload button below."
      size="large"
    >
      <Flex direction="row" gap="3" align="center" justify="center">
        <Button
          startIcon={<IconUpload />}
          variant="classic"
          color="secondary"
          type="button"
          onClick={onUploadClick}
        >
          Upload CSV Files
        </Button>
      </Flex>
    </EmptyContent>
  );
};
